<script>
import { Line } from 'vue-chartjs'
import 'chartjs-plugin-colorschemes';

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}
function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export default {
  extends: Line,
  props: ['data'],
  mounted () {
    const data = {
      labels: this.data.map(row => row.date),
      datasets: [
        {
          label: 'Minutes to Attempt',
          data: this.data.map(row => row.elapsed),
        },
      ],
    };
    const options = {
      scales: {
      },
    };
    this.renderChart(data, options);
  }
}
</script>
